module.exports = __webpack_public_path__ + "static/media/michelle_tran_bui.81370f4c.png";